const videoURL = __PROD__
  ? 'https://toifeeds.indiatimes.com/treact/feeds/toi/web/list/'
  : 'https://pwastg.timesofindia.com/feeds/toi/web/list/';

// const videoURL =
//   'https://toifeeds.indiatimes.com/treact/feeds/toi/web/list/video';

const getVideoFeedUrl = ({
  path = '',
  perpage = '',
  curpg = 1,
  reqtype = '',
  isNewVideoPath = false,
}) => {
  const perpageParam = perpage ? `&perpage=${perpage}` : '';
  const curpgParam = curpg ? `&curpg=${curpg}` : '';
  const reqtypeParam = reqtype ? `&reqtype=${reqtype}` : '';
  if (typeof window === 'object') {
    return `${videoURL}${
      isNewVideoPath ? 'videos' : 'video'
    }?path=${path}${perpageParam}${curpgParam}${reqtypeParam}`;
  }
  return `${videoURL}${
    isNewVideoPath ? 'videos' : 'video'
  }?path=${path}${perpageParam}${curpgParam}${reqtypeParam}`.replace(
    'https',
    'http',
  );
};

export default getVideoFeedUrl;
